export function errString(err: any): string {
  if (err instanceof Error) {
    return err.name + ": " + err.message;
  } else {
    return String(err);
  }
}
